/**
 * Oxbow Theme JavaScript
 * Handles: mobile menu, FAQ accordion, product gallery, quantity selector, cart AJAX
 */

document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initFaqAccordion();
  initProductGallery();
  initQuantitySelector();
  initCartAjax();
  initImageZoomPan();
});

/* --- Image Zoom & Pan --- */
function initImageZoomPan() {
  document.body.addEventListener('mouseover', (e) => {
    const wrap = e.target.closest('.zoom-pan-wrap');
    if (!wrap || wrap.dataset.zoomBound) return;
    
    wrap.dataset.zoomBound = 'true';
    const img = wrap.querySelector('.zoom-pan-img');
    if (!img) return;

    wrap.addEventListener('mousemove', (moveEvent) => {
      const rect = wrap.getBoundingClientRect();
      const x = ((moveEvent.clientX - rect.left) / rect.width) * 100;
      const y = ((moveEvent.clientY - rect.top) / rect.height) * 100;
      
      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform = 'scale(1.5)';
    });

    wrap.addEventListener('mouseleave', () => {
      img.style.transformOrigin = 'center center';
      img.style.transform = 'scale(1)';
    });
  });
}

/* --- Mobile Menu --- */
function initMobileMenu() {
  const toggle = document.getElementById('menu-toggle');
  const nav = document.getElementById('mobile-nav');
  if (!toggle || !nav) return;

  toggle.addEventListener('click', () => {
    const isOpen = toggle.classList.toggle('active');
    nav.classList.toggle('open');
    nav.setAttribute('aria-hidden', !isOpen);
    toggle.setAttribute('aria-expanded', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });
}

/* --- FAQ Accordion --- */
function initFaqAccordion() {
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isActive = item.classList.contains('active');

      // Close all
      document.querySelectorAll('.faq-item.active').forEach(el => {
        el.classList.remove('active');
        el.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
      });

      // Toggle current
      if (!isActive) {
        item.classList.add('active');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

/* --- Product Gallery (thumbnail click) --- */
function initProductGallery() {
  const main = document.getElementById('main-product-image');
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  if (!main || !thumbs.length) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      main.src = thumb.dataset.full;
      main.alt = thumb.alt;
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });
}

/* --- Quantity Selector --- */
function initQuantitySelector() {
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.quantity-selector').querySelector('.qty-input');
      let val = parseInt(input.value) || 1;

      if (btn.dataset.action === 'increase') {
        input.value = val + 1;
      } else if (btn.dataset.action === 'decrease' && val > 1) {
        input.value = val - 1;
      }
    });
  });
}

/* --- Cart Logic (Drawer + AJAX) --- */
function initCartAjax() {
  const cartLink = document.querySelector('.header__cart');
  const drawer = document.getElementById('CartDrawer');
  const overlay = document.getElementById('CartDrawerOverlay');
  
  if (cartLink && drawer) {
    cartLink.addEventListener('click', (e) => {
      e.preventDefault();
      openCartDrawer();
    });
  }
  
  if (overlay) {
    overlay.addEventListener('click', closeCartDrawer);
  }
  
  // Delegate events for cart actions
  document.body.addEventListener('click', (e) => {
    // Close drawer
    if (e.target.closest('#CartDrawerClose') || e.target.closest('#CartDrawerCloseEmpty')) {
      closeCartDrawer();
    }
    
    // Quantity change (+ / - buttons)
    if (e.target.classList.contains('qty-btn')) {
      const btn = e.target;
      const input = btn.parentElement.querySelector('.qty-input');
      const key = btn.dataset.key;
      const action = btn.dataset.action;
      
      let qty = parseInt(input.value);
      if (action === 'increase') qty += 1;
      else if (action === 'decrease') qty -= 1;
      
      if (qty < 0) qty = 0;
      input.value = qty;
      
      updateCartItem(key, qty);
    }
    
    // Remove item
    if (e.target.classList.contains('cart-drawer__remove') || e.target.classList.contains('cart-item__remove')) {
      e.preventDefault();
      const key = e.target.dataset.key || new URL(e.target.href).searchParams.get('id');
      if (key) {
        updateCartItem(key, 0);
      }
    }
  });

  // Product Add to Cart Form
  const form = document.getElementById('product-form');
  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(form);
      const data = {
        id: parseInt(formData.get('id')),
        quantity: parseInt(formData.get('quantity')) || 1
      };

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        });

        if (res.ok) {
          const btn = form.querySelector('[type="submit"]');
          const originalText = btn.textContent;
          btn.textContent = '✓ Added!';
          btn.style.backgroundColor = '#43a047';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.style.backgroundColor = '';
          }, 2000);
          
          await refreshCartDrawer();
          openCartDrawer();
        }
      } catch (err) {
        console.error('Cart error:', err);
      }
    });
  }
}

function openCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  const overlay = document.getElementById('CartDrawerOverlay');
  if (drawer) drawer.classList.add('active');
  if (overlay) overlay.classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  const overlay = document.getElementById('CartDrawerOverlay');
  if (drawer) drawer.classList.remove('active');
  if (overlay) overlay.classList.remove('active');
  document.body.style.overflow = '';
}

async function updateCartItem(key, quantity) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    
    // Check if we are on the cart page
    if (window.location.pathname === '/cart') {
      window.location.reload();
    } else {
      await refreshCartDrawer();
    }
  } catch (err) {
    console.error('Update error:', err);
  }
}

async function refreshCartDrawer() {
  try {
    // 1. Fetch updated cart count
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    const countEl = document.getElementById('cart-count');
    if (countEl) countEl.textContent = cart.item_count;

    // 2. Fetch updated drawer HTML using Section Rendering API
    const res = await fetch('/?section_id=cart-drawer');
    const text = await res.text();
    
    // Parse HTML and extract inner structure
    const parser = new DOMParser();
    const html = parser.parseFromString(text, 'text/html');
    const newDrawerInner = html.querySelector('.cart-drawer__inner');
    
    const currentDrawer = document.getElementById('CartDrawer');
    if (currentDrawer && newDrawerInner) {
      currentDrawer.innerHTML = '';
      currentDrawer.appendChild(newDrawerInner);
    }
  } catch (err) {
    console.error('Refresh error:', err);
  }
}
